import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_LHead = _resolveComponent("LHead");
  const _component_router_view = _resolveComponent("router-view");
  const _component_LFooter = _resolveComponent("LFooter");
  const _component_el_scrollbar = _resolveComponent("el-scrollbar");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_LHead), _createVNode(_component_el_scrollbar, {
    height: "calc(100vh - 72px)"
  }, {
    default: _withCtx(() => [_createVNode(_component_router_view), _createVNode(_component_LFooter)]),
    _: 1
  })]);
}